const oysterConfig = {
  cartItemRowSelector: '.quickCartWrap .product-item',
  renderBadgeOnSpecifiedSelector: '.oyster-protection-widget',
  apiKey: "api_Ec9twopHQCxryKLy",
  integrationID: "integration_32sNGsd8nx54BRjuN",
  invertBadgeColor: false
};

window.addEventListener("load", function() {
  window.oyster.init({
    apiKey: oysterConfig.apiKey,
    integrationID: oysterConfig.integrationID
  });

  window.oyster.shopify.cart(undefined, { 
    products: [], 
    addBadgeToItems: true, 
    invertBadgeColor: oysterConfig.invertBadgeColor, 
    cartItemRowSelector: oysterConfig.cartItemRowSelector, 
    renderBadgeOnSpecifiedSelector: oysterConfig.renderBadgeOnSpecifiedSelector
  });
});